<template>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-8 bg-light border py-2">
            <table id="myRepPatSummaryTable" class="table table-striped table-hover table-bordered table-sm" style="width: 100%;">
                <thead class="text-dark" style="background:NavajoWhite">
                <tr>
                    <th>ชื่อ-สกุล #1</th>
                    <th>ชื่อ-สกุล #2</th>
                    <th>เพศ</th>
                    <th>อายุ</th>
                    <th>จำนวนครั้ง</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <!-- <template v-for="item in datalists" :key="item.PatID"> -->
                <tr v-for="item in datalists" :key="item.itemtestid" @click="tableChanged(item)">
                  <td class="text-start">{{ item.PatName }} {{ item.PatLName }}</td>
                  <td class="text-start">{{ item.PatName2 }} {{ item.PatLName2 }}</td>
                  <td class="">{{ arrSex[item.Sex] }}</td>
                  <td class="">{{ item.AgeYears }}</td>
                  <td class="text-start">{{ item.FreqTimes }}</td>
                  <td class="">
                    <button class="btn btn-sm py-0 btn-warning" title="พิมพ์ประวีติการตรวจของคนไข้รายนี้"
                      @click="printHealthCheckHistory(item)">พิมพ์</button>
                  </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="col-sm-4 bg-light p-0 py-2">
            <RepPatSummary2PatTestList
            :show="true"
            :datalists2="datalists2"
            :branchID="branchID"
            :dateFm="dateFm" :dateTo="dateTo"
            :patID="patID"></RepPatSummary2PatTestList>
        </div>
      </div>
    </div>

    <div id="divToPrint" hidden>
      <span data-pdfmake="{&quot;fontSize&quot;:&quot;16&quot;, &quot;bold&quot;:&quot;true&quot;}">ประวัติการมารับบริการ</span>
      <table style="width:100%" data-pdfmake="{&quot;layout&quot;:&quot;lightHorizontalLines&quot;}">
        <thead>
          <tr>
            <th>วันที่</th>
            <th>เลขที่</th>
            <th>รายการตรวจ</th>
            <th>ผลการตรวจ</th>
            <th>ผู้ให้บริการ</th>
          </tr>
        </thead>
        <tr v-for="item in reportDtl" :key="item.ROID">
          <td style="width:60px;">{{item.DocDate}}</td>
          <td style="width:80px;">{{item.RONo}}</td>
          <td style="width:260px;" ><b>{{item.ItemTestName}}</b></td>
          <td style="width:80px;" > {{item.Result}}  </td>
          <td style="width:155px;" >{{item.AppvName}}</td>
        </tr>
      </table>
      <br>
    </div>
</template>

<script>
import RepPatSummary2PatTestList from './RepPatSummary2PatTestList.vue'

// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import JsBarcode from 'jsbarcode/bin/JsBarcode'
import pdfMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import htmlToPdfmake from 'html-to-pdfmake'
pdfMake.vfs = pdfFonts.pdfMake.vfs
// // ต้องระบุตามชื่อของ ไฟล์ font
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'RepPatSummary1',
  components: {
    RepPatSummary2PatTestList
  },
  data () {
    return {
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'Male', 'Female'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      datalists: [],
      datalists2: [],
      // เงื่อนไขสำหรับดึงข้อมูลย่อย
      patID: 0,
      countRefresh1: 0,
      // สำหรับออกรายงาน พิมพ์ Pdf
      reportDtl: null,
      reportHd: {
        PatID: 0,
        PatCode: '',
        PrefixName: '',
        PatName: 'สมชาย แข็งแรงดี',
        PatLName: '',
        PrefixName2: '',
        PatName2: '',
        PatLName2: '',
        IDNo: '',
        Sex: 0,
        Addr1: '',
        Tambon: '',
        Amphor: '',
        Province: '',
        PostCode: '',
        Tel1: '',
        Tel2: '',
        AgeYears: 0,
        AgeMonths: 0,
        AgeDays: 0
      },
      reportBrHd: {
        BranchID: 0,
        BranchName: '',
        Addr1: '',
        Tambon: '',
        Amphor: '',
        Province: '',
        PostCode: '',
        Tel1: '',
        Tel2: '',
        Email1: '',
        Email2: ''
      }
    }
  },
  // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
  props: ['branchID', 'dateFm', 'dateTo'],
  created () {
    // Initial Value
  },
  mounted () {
    this.getData()
  },
  methods: {
    // ดึงข้อมูล Level ถัดไป
    tableChanged (row) {
      this.patID = row.PatID
      this.getData2()
      // console.log(row)
    },
    StatusLN (status) {
      return this.arrDocStatus[status]
    },
    SexMF (sex) {
      return this.arrSex[sex]
    },
    // ดึงข้อมูลของ component ตัวเอง
    getData () {
      var docDateFm = this.dateFm.toISOString().slice(0, 10)
      var docDateTo = this.dateTo.toISOString().slice(0, 10)
      var BranchID = this.branchID
      MyApiClient.get('getdata/reppatsummary1patlist_where.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID + '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.datalists = resp.data.response
          if (this.datalists == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          this.$nextTick(() => {
            $('#myRepPatSummaryTable').DataTable()
          })
          // setTimeout(function () { $('#myRepLabStatusTable').DataTable() }, 0)
          this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getData2 () {
      var docDateFm = this.dateFm.toISOString().slice(0, 10)
      var docDateTo = this.dateTo.toISOString().slice(0, 10)
      var BranchID = this.branchID
      var PatID = this.patID
      // console.log('PatID : ')
      // console.log(this.patID)
      MyApiClient.get('getdata/reppatsummary2pattestlist_where.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID +
        '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo + '&PatID=' + PatID)
        .then((resp) => {
        //   console.log(resp.data.response)
          var rows = Object.assign({}, resp.data.response)
          this.datalists2 = rows
          // this.datalists2 = resp.data.response
          if (this.datalists2 == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          this.$nextTick(() => {
            this.countRefresh1++
            // $('#myRepPatSummaryTable2').DataTable()
          })
          // setTimeout(function () { $('#myRepLabStatusTable').DataTable() }, 0)
          this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    printHealthCheckHistory (row) {
      // ดึงข้อมูลให้เสร็จก่อนแล้วค่อยสร้างรายงาน เรียกแบบ promise
      //  getReportDtlData(row) -> getReportHdData (row) -> getReportBranchHdData() -> createPdfForm1ToScreen ()
      this.getReportDtlData(row)
    },
    // ดึงชื่อ ที่อยู่สาขา สำหรับพิมพ์เป็นหัวกระดาษ
    getReportBranchHdData () {
      // var self = this
      // MyApiClient.get('getdata/lab_pat_history_br_hd_where.php?branchID=' + self.branchID)
      //   .then((resp) => {
      //     self.dataheader = resp.data.response
      //     self.reportBrHd.BranchName = self.dataheader[0].BranchName
      //     self.reportBrHd.Addr1 = self.dataheader[0].Addr1
      //     self.reportBrHd.Tambon = self.dataheader[0].Tambon
      //     self.reportBrHd.Amphor = self.dataheader[0].Amphor
      //     self.reportBrHd.Province = self.dataheader[0].Province
      //     self.reportBrHd.PostCode = self.dataheader[0].PostCode
      //     self.reportBrHd.Tel1 = self.dataheader[0].Tel1
      //     self.reportBrHd.Tel2 = self.dataheader[0].Tel2
      //     self.createPdfForm1ToScreen()
      //   })
      //   .catch((err) => {
      //     console.log(err.response)
      //   })
      console.log(this.reportDtl)
      this.createPdfForm1ToScreen()
    },
    getReportHdData (row) {
      var self = this
      MyApiClient.get('getdata/lab_pat_history_hd_where.php?patID=' + row.PatID)
        .then((resp) => {
          self.dataheader = resp.data.response
          self.reportHd.PatCode = self.dataheader[0].PatCode
          self.reportHd.PrefixName = self.dataheader[0].PrefixName
          self.reportHd.PatName = self.dataheader[0].PatName
          self.reportHd.PatLName = self.dataheader[0].PatLName
          self.reportHd.PrefixName2 = self.dataheader[0].PrefixName2
          self.reportHd.PatName2 = self.dataheader[0].PatName2
          self.reportHd.PatLName2 = self.dataheader[0].PatLName2
          self.reportHd.IDNo = self.dataheader[0].IDNo
          self.reportHd.Sex = self.dataheader[0].Sex
          self.reportHd.Addr1 = self.dataheader[0].Addr1
          self.reportHd.Tambon = self.dataheader[0].Tambon
          self.reportHd.Amphor = self.dataheader[0].Amphor
          self.reportHd.Province = self.dataheader[0].Province
          self.reportHd.PostCode = self.dataheader[0].PostCode
          self.reportHd.Tel1 = self.dataheader[0].Tel1
          self.reportHd.Tel2 = self.dataheader[0].Tel2
          self.reportHd.AgeYears = self.dataheader[0].AgeYears
          self.reportHd.AgeMonths = self.dataheader[0].AgeMonths
          self.reportHd.AgeDays = self.dataheader[0].AgeDays
          self.reportHd.CongDisease = self.dataheader[0].CongDisease
          self.reportHd.DrugAllergy = self.dataheader[0].DrugAllergy
          self.getReportBranchHdData()
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getReportDtlData (row) {
      var docDateFm = this.dateFm.toISOString().slice(0, 10)
      var docDateTo = this.dateTo.toISOString().slice(0, 10)
      var BranchID = this.branchID
      var PatID = row.PatID
      var self = this
      MyApiClient.get('getdata/lab_pat_history_dtl_where.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID +
        '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo + '&PatID=' + PatID)
        .then((resp) => {
          // console.log(resp.data.response)
          self.reportDtl = resp.data.response
          self.getReportHdData(row)
          // console.log()
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    createPdfForm1ToScreen () {
      console.log(this.reportHd.PatName)
      var PatNamePrn = this.reportHd.PatName
      var PatLNamePrn = this.reportHd.PatLName
      var PrefixNamePrn = this.reportHd.PrefixName
      // if (this.nameIdx === 2) {
      //   PatNamePrn = this.reportHd.PatName2
      //   PatLNamePrn = this.reportHd.PatLName2
      //   PrefixNamePrn = this.reportHd.PrefixName2
      // }
      // ==================================== //
      // var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        // pageOrientation: 'landscape',
        pageMargins: [30, 250, 30, 50],
        header: {
          margin: [30, 30, 30, 100],
          table: {
            widths: [130, 150, 120, 80],
            body: [
              [
                {
                  text: this.globalCorpName + ' ' + this.reportBrHd.BranchName,
                  bold: true,
                  colSpan: 3,
                  alignment: 'left',
                  margin: [0, 0, 0, 0],
                  fontSize: 14,
                  lineHeight: 0.6
                },
                {}, {}, {}
              ],
              [
                {
                  text: this.globalCorpInfo.addr1 + ' ' + this.globalCorpInfo.addr2 + ' ' + this.globalCorpInfo.tambol + ' ' +
                        this.globalCorpInfo.amphor + ' ' + this.globalCorpInfo.province + ' ' + this.globalCorpInfo.zipcode,
                  bold: false,
                  colSpan: 3,
                  alignment: 'left',
                  margin: [0, 0, 0, 0],
                  fontSize: 14,
                  lineHeight: 0.6
                },
                {}, {}, {}
              ],
              [
                { text: 'ประวัติการรักษา', bold: true, colSpan: 4, alignment: 'center', margin: [0, 20, 0, 0], fontSize: 16 },
                {}, {}, {}
              ],
              [
                { text: 'ชื่อ นามสกุล / Name', margin: [5, 0, 0, 0], bold: true, fontSize: 14, lineHeight: 0.6 },
                { text: PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn, margin: [5, 0, 0, 0], fontSize: 14, lineHeight: 0.6 },
                { text: 'อายุ / Age', margin: [5, 0, 0, 0], bold: true, fontSize: 14, lineHeight: 0.6 },
                { text: this.reportHd.AgeYears + '.' + this.reportHd.AgeMonths + '.' + this.reportHd.AgeDays + ' years', margin: [5, 0, 0, 0], fontSize: 14, lineHeight: 0.6 }
              ],
              [
                { text: 'หมายเลขบัตรประชาชน / ID card number', margin: [5, 0, 0, 0], bold: true, colSpan: 2, fontSize: 14, lineHeight: 0.6 },
                {},
                { text: this.reportHd.PatCode, margin: [5, 0, 0, 0], colSpan: 2, fontSize: 14, lineHeight: 0.6 },
                {}
              ],
              [
                { text: 'เพศ / Gender ', margin: [5, 0, 0, 0], bold: true, fontSize: 14 },
                { text: this.arrSex[this.reportHd.Sex], margin: [5, 0, 0, 0], fontSize: 14 },
                {},
                {}
              ],
              [
                { text: 'ที่อยู่ / Address ', margin: [5, 0, 0, 0], bold: true, fontSize: 14, lineHeight: 0.6 },
                { text: this.reportHd.Addr1 + ' ' + this.reportHd.Tambon + ' ' + this.reportHd.Amphor + ' ' + this.reportHd.Province, margin: [5, 0, 0, 0], fontSize: 14, colSpan: 3, lineHeight: 0.6 },
                {},
                {}
              ],
              [
                { text: 'โทรศัพท์1 / Phone no.1', margin: [5, 0, 0, 0], bold: true, fontSize: 14 },
                { text: this.reportHd.Tel1, margin: [5, 0, 0, 0], fontSize: 14 },
                { text: 'โทรศัพท์2 / Phone no.2', margin: [5, 0, 0, 0], bold: true, fontSize: 14 },
                { text: this.reportHd.Tel2, margin: [5, 0, 0, 0], fontSize: 14 }
              ],
              [
                { text: 'โรคประจำตัว / Cong Disease', margin: [5, 0, 0, 0], bold: true, fontSize: 14, lineHeight: 0.6 },
                { text: this.reportHd.CongDisease, margin: [5, 0, 0, 0], fontSize: 14, colSpan: 3, lineHeight: 0.6 },
                { },
                { }
              ],
              [
                { text: 'ยาที่แพ้ / Drug allergy', margin: [5, 0, 0, 0], bold: true, fontSize: 14 },
                { text: this.reportHd.DrugAllergy, margin: [5, 0, 0, 0], fontSize: 14, colSpan: 3 },
                { },
                { }
              ]
            ]
          },
          layout: 'noBorders'
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [40, 10, 40, 20],
            table: {
              widths: [200, 150, 150],
              body: [
                [
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 12
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    }
  }
}
</script>

<style>

</style>
